import React from 'react';
import { View, Dimensions, Text, Image, ScrollView, ActivityIndicator } from 'react-native';
import { CheckBox, Button } from 'react-native-elements';
import Lib from '../Lib';

const { showToast, getStorageValue, setStorageValue, clearStorageValue } = Lib;
const { IMG_DATA, USDT, TOKEN, TOKEN_NAME, GAS } = require('../Data');
const { isWalletAvailable, connectToWallet, subscribeWalletData, publishWalletData } = require('../BlockLib');

class PanelHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: 'busy'
    };
  }

  async componentDidMount() {
    this.busy = false;
    this.interval = setInterval(() => this.refresh(), 3000);
    try {
      const available = await isWalletAvailable();
      const haveConnectedBefore = await getStorageValue('HAVE_CONNECTED_BEFORE');
      if (available && haveConnectedBefore) {
        return await this.connectWallet();
      }
    } catch (err) {
      // todo: popup error
      console.error(err);
      if (err.message) showToast(err.message.toUpperCase());
    }

    await clearStorageValue();
    this.setState({
      show: 'disconnected'
    });
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  async refresh() {
    if (this.state.show !== 'connected') return;
    if (this.busy) return;
    this.busy = true;

    // todo here ??

    this.busy = false;
  }

  async connectWallet() {
    this.setState({ show: 'busy' });
    try {
      await connectToWallet();
      await setStorageValue('HAVE_CONNECTED_BEFORE', true);
      subscribeWalletData((data) => {
        this.setState({
          show: 'connected',
          usdt: data.usdt,
          token: data.token,
          gas: data.gas
        });
      })
      return await publishWalletData();
    } catch (err) {
      // todo: popup error
      console.error(err);
      if (err.message) showToast(err.message.toUpperCase());
    }

    await clearStorageValue();
    this.setState({
      show: 'disconnected'
    });
  }

  render() {
    let right;

    if (this.state.show === 'busy') {
      right = (
        <View style={{ alignItems: 'flex-end' }}>
          <ActivityIndicator />
        </View>
      );
    } else if (this.state.show === 'connected') {
      const token = this.state.token;
      const usdt = this.state.usdt;
      const gas = this.state.gas;
      right = (
        <View style={{ alignItems: 'flex-end' }}>
          <Text style={{ color: 'white' }}>{token} {TOKEN} | {usdt} {USDT} | {gas} {GAS}</Text>
        </View>
      );
    } else {
      right = (
        <View style={{ alignItems: 'flex-end' }}>
          <Button title="CONNECT" onPress={() => this.connectWallet()} />
        </View>
      );
    }

    return (
      <View style={{ padding: 20, backgroundColor: 'gray'}}>
        <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
          <View>
            <Text style={{ textAlign: 'left', color: 'white', fontWeight: 'bold' }}>RTK WARRIORS</Text>
          </View>
          {right}
        </View>
      </View>
    );
  }

}

export default PanelHeader;
